import React from 'react'

import { startCase } from 'lodash'

import VerticalBarChart, { VChartSeries } from '@/components/ui/charts/vertical-bar-chart/VerticalBarChart'
import Drilldown from '@/insights/components/Drilldown'
import { severityCodes } from '@/insights/components/SeverityDropdown'
import type { AssetMake } from '@/types/dashboard-types'
import { InsightConfigurationType } from '@/types/dashboard-types'

import { ReeferAlarmCountByReeferMakeParams } from './ReeferAlarmCountByReeferMake'

type SeverityType = 'critical' | 'warning' | 'informational'

const BarChart = ({ configuration, data }: { configuration: InsightConfigurationType; data: AssetMake[] }) => {
  const [activeDrilldown, setActiveDrilldown] = React.useState<InsightConfigurationType | null>(null)

  const severityColorMap = {
    critical: '#F18484',
    warning: '#FFC75C',
    informational: '#6AC380',
  }

  const xAxisData = data.map((item) => item.make)
  const severities = (
    (configuration.parameters?.severities as SeverityType[])?.length
      ? configuration.parameters.severities
      : ['critical', 'warning', 'informational']
  ) as SeverityType[]

  const series: VChartSeries[] = severities.map((s) => ({
    name: startCase(s),
    data: data.map((item) => item[s]),
    color: severityColorMap[s],
    stack: 'alarms',
  }))

  const handleBarClick = (params: { seriesName: string; name: string }) => {
    const clickedMake = params.name
    const clickedSeverity = params.seriesName.toLowerCase()
    const parameters = configuration.parameters as ReeferAlarmCountByReeferMakeParams

    const severityCode = severityCodes.find((s) => s.label.toLowerCase() === clickedSeverity)?.value

    const ddConfig: InsightConfigurationType = {
      ...configuration,
      slug: 'alarm/alarms-detail',
      title: `${configuration.title}: ${clickedMake} - ${params.seriesName}`,
      parameters: {
        ...parameters,
        displayFormat: 'table',
        severity: severityCode,
        makes: clickedMake,
      },
    }

    setActiveDrilldown(ddConfig)
  }

  return (
    <>
      {activeDrilldown && <Drilldown configuration={activeDrilldown} onClose={() => setActiveDrilldown(null)} />}
      <VerticalBarChart showLegend xAxisData={xAxisData} series={series} onBarClick={handleBarClick} />
    </>
  )
}

export default BarChart
